export default __webpack_public_path__ + "static/BenRev-14f286e61de688b1cb315da32080c9cd.jpg";